<template>
  <div class="login">
    <div class="login-container">
      <div class="title">石家庄道路运输行业协会报名培训后台管理系统</div>
      <div style="width: 550px; margin: 0 auto">
        <el-form :model="ruleForm" label-width="60px">
          <el-form-item label="账号：">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="密码：">
            <el-input type="password" v-model="ruleForm.pass"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div style="text-align: center">
        <el-button type="primary" style="width: 550px" @click="onSubmit()"
          >登录</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { login } from "../api/main";
export default {
  data() {
    return {
      ruleForm: {
        name: "",
        pass: "",
      },
    };
  },
  methods: {
    onSubmit() {
      if (this.ruleForm.name == "") {
        this.$message.error("用户名不能为空！");
        return;
      }
      if (this.ruleForm.pass == "") {
        this.$message.error("密码不能为空！");
        return;
      }
      login({
        name: this.ruleForm.name,
        password: this.ruleForm.pass,
      }).then((res) => {
        console.log(res);
        if (res.code == 1) {
          sessionStorage.setItem("token", res.data);
          sessionStorage.setItem("username", this.ruleForm.name);
          this.$router.push("/Index");
          this.$message.success("登录成功");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less">
.login {
  height: 100vh;
  width: 100vw;
  background: url(../assets/login-background.png);
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  .login-container {
    height: 300px;
    width: 700px;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 16px;
    font-size: 25px;
    .title {
      height: 100px;
      line-height: 100px;
      text-align: center;
      font-size: 25px;
      color: rgb(64, 158, 255);
    }
  }
}
</style>